import type { TourSection } from './types';

export const adminRagSections: TourSection[] = [
  {
    id: 'overview',
    label: 'Qué es el reindex',
    steps: [
      {
        target: '[data-tour="rag-header"]',
        title: 'Reindex RAG',
        content:
          'El catálogo se sincroniza automáticamente con el motor de búsqueda semántica (RAG) cada vez que un producto cambia. Esta página es para forzar una resincronización manual de productos específicos cuando algo quedó desalineado.',
      },
    ],
  },
  {
    id: 'input',
    label: 'Ingresar SKUs',
    steps: [
      {
        target: '[data-tour="rag-input"]',
        title: 'Lista de SKUs',
        content:
          'Pega los SKUs uno por línea o como lista separada por comas. El sistema detecta automáticamente cuántos son válidos y te muestra el conteo. Máximo 10.000 a la vez.',
      },
    ],
  },
  {
    id: 'run',
    label: 'Ejecutar',
    steps: [
      {
        target: '[data-tour="rag-run"]',
        title: 'Disparar reindex',
        content:
          'Procesa los SKUs en lotes de 500. Si pegaste muchos, vas a ver una barra de progreso indicando qué lote va. Si un lote falla, el proceso se detiene.',
      },
    ],
  },
  {
    id: 'results',
    label: 'Ver resultados',
    steps: [
      {
        target: '[data-tour="rag-results"]',
        title: 'Resumen del proceso',
        content:
          'Total procesados y total con errores. Si hubo fallas, te lista los SKUs que rompieron con el motivo, para que puedas reintentarlos.',
      },
    ],
  },
];
